import { render, staticRenderFns } from "./useInfo.vue?vue&type=template&id=5d6ac842&scoped=true"
import script from "./useInfo.vue?vue&type=script&lang=js"
export * from "./useInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d6ac842",
  null
  
)

export default component.exports